import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

const addPresentation = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('addPresentation', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

const fetchPresentationInfo = async (presentationId) => {
	try {
		const { data } = await ApiClient.GET('getPresentationInfo', `${presentationId}/info`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

const savePresentationSequence = async (requestBody, presentationId) => {
	try {
		const { data } = await ApiClient.POST(`savePresentationSequence`, requestBody, `/${presentationId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

const getPresentationLink = async (presentationId) => {
	try {
		const { data } = await ApiClient.GET(`getPresentationLink`, presentationId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export { addPresentation, fetchPresentationInfo, savePresentationSequence, getPresentationLink };
